"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var registration_service_1 = require("@pbl/pbl-react-core/lib/services/registration-service");
var Icon_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/icon/Icon"));
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var colorsV2_1 = __importDefault(require("../../assets/jss/colorsV2"));
var registration_1 = require("../../config/registration");
var validation_1 = __importDefault(require("../../config/validation"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/authentication/actions");
var action_1 = require("../../redux/reducers/user-registration/action");
var AccessibleDisabledButton_1 = __importDefault(require("../../shared/components/button/AccessibleDisabledButton"));
var ReCaptcha_1 = __importDefault(require("../../shared/components/input/ReCaptcha"));
var framework_1 = require("../../widgets/framework");
var AccountCredentials_1 = __importDefault(require("./components/AccountCredentials"));
var Confirmation_1 = __importDefault(require("./components/Confirmation"));
var PersonalInformation_1 = __importDefault(require("./components/PersonalInformation"));
var RegistrationStepper_1 = __importDefault(require("./components/RegistrationStepper"));
var styles_1 = __importDefault(require("./styles"));
var UserRegistrationScreen = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.userRegistration; }), userRegistrationData = _a.userRegistrationData, registrationSucceeded = _a.registrationSucceeded, error = _a.error;
    var authorizedFlags = (0, react_redux_1.useSelector)(function (state) { return state.feature; }).authorizedFlags;
    var _b = (0, react_1.useState)(false), tosChecked = _b[0], setTosChecked = _b[1];
    var _c = (0, react_1.useState)(false), over18Checked = _c[0], setOver18Checked = _c[1];
    var _d = (0, react_1.useState)(0), step = _d[0], setStep = _d[1];
    var _e = (0, react_1.useState)(false), showCaptcha = _e[0], setShowCaptcha = _e[1];
    var _f = (0, react_1.useState)({
        address1: '',
        address2: '',
        city: '',
        country: '',
        countryCode: '',
        state: '',
        zipCode: '',
        apartmentNumber: ''
    }), address = _f[0], setAddress = _f[1];
    var accountCredentialsFields = registration_1.registrationFields
        .filter(function (x) { return x.page === 0; })
        .map(function (x) {
        x.value = userRegistrationData[x.key];
        return x;
    });
    var personalInformationFields = registration_1.registrationFields
        .filter(function (x) { return x.page === 1; })
        .map(function (x) {
        x.value = userRegistrationData[x.key];
        return x;
    });
    var isValidAccountCredentials = userRegistrationData.isValidAccountCredentials, isValidPersonalInformation = userRegistrationData.isValidPersonalInformation, recaptcha = userRegistrationData.recaptcha, phone = userRegistrationData.phone, isValidZipCode = userRegistrationData.isValidZipCode, getDateOfBirth = userRegistrationData.getDateOfBirth;
    var isNextEnabled = step === 0
        ? isValidAccountCredentials &&
            tosChecked &&
            over18Checked &&
            (0, moment_1.default)(getDateOfBirth).isBetween(validation_1.default.minDateOfBirth, validation_1.default.maxDateOfBirth)
        : isValidPersonalInformation && phone && isValidZipCode;
    var onNext = function () { return (step === 0 ? validateAccountData(1) : register(2)); };
    (0, react_1.useEffect)(function () {
        dispatch((0, actions_2.isAuthenticated)());
        return function () {
            resetState();
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (registrationSucceeded) {
            setShowCaptcha(false);
            dispatch((0, actions_1.clearMessages)());
            dispatch((0, actions_1.clearLoading)());
            setStep(2);
        }
    }, [registrationSucceeded]);
    (0, react_1.useEffect)(function () {
        dispatch((0, action_1.updateUserRegistrationField)('address', address));
    }, [address]);
    (0, react_1.useEffect)(function () {
        if (recaptcha) {
            doRegister();
        }
    }, [recaptcha]);
    (0, react_1.useEffect)(function () {
        if (error) {
            dispatch((0, actions_1.showMessageBar)({
                type: 'error',
                message: error === null || error === void 0 ? void 0 : error.message
            }));
            dispatch((0, actions_1.clearLoading)());
        }
    }, [error]);
    var updateFields = function (fieldName, value) {
        dispatch((0, action_1.updateUserRegistrationField)(fieldName, value));
    };
    var handleTosChecked = function () {
        setTosChecked(!tosChecked);
    };
    var handleOver18Checked = function () {
        setOver18Checked(!over18Checked);
    };
    var resetState = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, actions_1.clearMessages)());
            return [2];
        });
    }); };
    var handleAddressSelect = function (updatedAddress) {
        setAddress(updatedAddress);
    };
    var validateAccountData = function (position) { return __awaiter(void 0, void 0, void 0, function () {
        var checkEmail;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (position === 0 && step === 1) {
                        setStep(position);
                        return [2];
                    }
                    dispatch((0, actions_1.clearMessages)());
                    if (position > 0 && !isValidAccountCredentials) {
                        return [2];
                    }
                    return [4, registration_service_1.RegistrationService.checkEmail(userRegistrationData.email)];
                case 1:
                    checkEmail = _a.sent();
                    if (!(checkEmail === null || checkEmail === void 0 ? void 0 : checkEmail.message)) {
                        dispatch((0, actions_1.clearMessages)());
                        setStep(position);
                    }
                    else {
                        dispatch((0, actions_1.showMessageBar)({
                            type: 'error',
                            message: checkEmail.message
                        }));
                    }
                    return [2];
            }
        });
    }); };
    var onPersonalInformationBack = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, changeStepper(0)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var changeStepper = function (position) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (step === 2) {
                        return [2];
                    }
                    if (position > 1) {
                        return [2];
                    }
                    return [4, validateAccountData(position)];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }); };
    var register = function (_1) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!showCaptcha) return [3, 2];
                    return [4, doRegister()];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    dispatch((0, actions_1.toggleLoading)({ spinning: true, label: 'Registering' }));
                    setShowCaptcha(true);
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var doRegister = function () { return __awaiter(void 0, void 0, void 0, function () {
        var authenticationV2;
        return __generator(this, function (_a) {
            authenticationV2 = authorizedFlags.includes('AUTHENTICATION_V2');
            if (isValidAccountCredentials) {
                dispatch((0, action_1.registerPlayer)(userRegistrationData, authenticationV2));
            }
            return [2];
        });
    }); };
    var onRecaptchaChange = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, action_1.updateUserRegistrationField)('recaptcha', value));
            return [2];
        });
    }); };
    var navigateToLogin = function () {
        var appNavigate = {
            action: 'LOGIN'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 11, sm: 11, md: 6 },
            react_1.default.createElement(core_1.Card, { raised: true, className: classes.registerCard },
                react_1.default.createElement(core_1.Grid, { container: true, alignItems: "center", justifyContent: "center" },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(core_1.Typography, { align: "center", component: "h2", variant: "h2", style: {
                                color: colorsV2_1.default.palette.neutralsN900.hex()
                            }, className: classes.titleText }, "Register")),
                    step !== 2 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, lg: 10, alignItems: "center", justifyContent: "center" },
                        react_1.default.createElement(RegistrationStepper_1.default, { onPress: changeStepper, activeStep: step }),
                        step === 1 && (react_1.default.createElement(core_1.Button, { onClick: onPersonalInformationBack, "aria-label": 'Previous Step', variant: 'text', color: 'primary', style: {
                                textTransform: 'none',
                                textDecoration: 'underline',
                                margin: theme.spacing(1, 0, 0, 1),
                                padding: 0
                            } },
                            react_1.default.createElement(Icon_1.default, { iconType: 'material', iconName: 'keyboard_arrow_left' }),
                            t('registrationPage.step2.previousStep'))),
                        react_1.default.createElement(core_1.Typography, { variant: "body1", style: {
                                color: colorsV2_1.default.palette.neutralsN900.hex(),
                                margin: theme.spacing(5.5, 2, 0)
                            } }, t('registrationPage.requiredInformation')))),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 12, container: true },
                        react_1.default.createElement(core_1.Grid, { style: { margin: theme.spacing() }, item: true, xs: 12, container: true, alignItems: "center", justifyContent: "center" },
                            step === 0 && (react_1.default.createElement(AccountCredentials_1.default, { passwordErrors: userRegistrationData.passwordErrors, updateField: updateFields, accountCredentialsFields: accountCredentialsFields, handleTosChecked: handleTosChecked, tosChecked: tosChecked, over18Checked: over18Checked, handleOver18Checked: handleOver18Checked })),
                            step === 1 && (react_1.default.createElement(PersonalInformation_1.default, { handleAddressSelect: handleAddressSelect, onBack: onPersonalInformationBack, updateField: updateFields, personalInformationFields: personalInformationFields, address: address })),
                            step === 2 && react_1.default.createElement(Confirmation_1.default, { navigateToLogin: navigateToLogin }),
                            step !== 2 && (react_1.default.createElement(AccessibleDisabledButton_1.default, { size: "large", variant: "contained", color: "primary", disabled: !isNextEnabled, onClick: onNext, className: classes.button, "aria-label": step === 0 ? 'Navigate to next step' : undefined, style: { padding: '12px 24px !important' }, type: step === 1 ? 'submit' : undefined }, step === 0 ? 'Next' : 'Save & Register'))),
                        step === 0 && (react_1.default.createElement(core_1.Grid, { style: { margin: theme.spacing() }, item: true, xs: 12, container: true, alignItems: "center", justifyContent: "center" },
                            react_1.default.createElement(core_1.Grid, { item: true, xs: "auto" },
                                react_1.default.createElement(core_1.Typography, { color: 'textSecondary' }, "Already have an account?")),
                            react_1.default.createElement(core_1.Grid, { item: true, xs: "auto" },
                                react_1.default.createElement(core_1.Button, { color: "primary", "aria-label": 'Sign In', onClick: navigateToLogin },
                                    "Sign In",
                                    react_1.default.createElement(core_1.Icon, { className: (0, classnames_1.default)('icon-sign-In') })))))),
                    showCaptcha && react_1.default.createElement(ReCaptcha_1.default, { action: "REGISTER", onChange: onRecaptchaChange }))))));
};
exports.default = UserRegistrationScreen;
//# sourceMappingURL=index.js.map